export function getStaticTimeInfo(day, shiftIndex, t) {
  // Get the shifts object for the given day
  const shifts = day?.workingTime;
  
  // Ensure that the day and shift index are valid
  if (!shifts || shifts[shiftIndex] == null) {
    return null;
  }

  const shift = shifts[shiftIndex]; // Get the shift object for the given index
  const { startTime, endTime } = shift; // Extract start and end times

  const bothDatesExist = startTime != null && endTime != null;
  const onlyEndTimeExists = endTime != null && startTime == null;
  const onlyStartTimeExists = startTime != null && endTime == null;

  if (bothDatesExist) {
    return `${startTime} - ${endTime}`;
  }

  if (onlyEndTimeExists) {
    return `${null} - ${endTime}`;
  }

  if (onlyStartTimeExists) {
    return `${startTime} - ${null}`;
  }

  return null;
}
